import { motion } from "framer-motion";
import { BookOpen, Calendar, PenLine, Moon, Share2 } from "lucide-react";

interface QuickActionsProps {
  currentDay: number;
  showLaylatulQadr: boolean;
  onOpenJournal: () => void;
  onOpenCalendar: () => void;
  onOpenLaylatulQadr: () => void;
  onOpenPeriods: () => void;
  onShareProgress: () => void;
}

export const QuickActions = ({
  showLaylatulQadr,
  onOpenJournal,
  onOpenCalendar,
  onOpenLaylatulQadr,
  onOpenPeriods,
  onShareProgress,
}: QuickActionsProps) => {
  const actions = [
    {
      icon: PenLine,
      label: "Journal",
      description: "Write reflections",
      onClick: onOpenJournal,
      color: "text-emerald-600",
      bg: "bg-emerald-50",
    },
    {
      icon: Calendar,
      label: "Calendar",
      description: "View all days",
      onClick: onOpenCalendar,
      color: "text-blue-600",
      bg: "bg-blue-50",
    },
    {
      icon: Share2,
      label: "Share",
      description: "Share progress",
      onClick: onShareProgress,
      color: "text-amber-600",
      bg: "bg-amber-50",
    },
  ];

  if (showLaylatulQadr) {
    actions.push({
      icon: Moon,
      label: "Laylatul Qadr",
      description: "Night of Power",
      onClick: onOpenLaylatulQadr,
      color: "text-purple-600",
      bg: "bg-purple-50",
    });
  }

  return (
    <div className="grid grid-cols-2 gap-3">
      {actions.map((action, index) => (
        <motion.button
          key={action.label}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 + index * 0.05 }}
          onClick={action.onClick}
          className={`${action.bg} rounded-lg p-4 text-left hover:shadow-sm transition-all group`}
        >
          <action.icon className={`w-5 h-5 ${action.color} mb-2 group-hover:scale-110 transition-transform`} />
          <p className="text-sm font-medium text-foreground">{action.label}</p>
          <p className="text-xs text-muted-foreground">{action.description}</p>
        </motion.button>
      ))}
    </div>
  );
};
